var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('PageBack'),_c('PageHeader',{attrs:{"title":_vm.$t('invoice.add_line_to_invoice')}}),_c('Form',{ref:"form",attrs:{"init-on-success":true,"fields":_vm.fields,"model":_vm.model,"action":_vm.addLineToInvoice},on:{"success":_vm.next}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }